import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase.config';
import Helmet from '../components/Helmet/Helmet';
import '../styles/product-detail.css';

const RetinaProductDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                setLoading(true);
                const docRef = doc(db, "retinaImages", id);
                const docSnap = await getDoc(docRef);
                
                if (docSnap.exists()) {
                    setProduct({
                        id: docSnap.id,
                        ...docSnap.data()
                    });
                } else {
                    setError("Product not found");
                }
            } catch (err) {
                console.error("Error fetching product:", err);
                setError("Failed to load product");
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchProduct();
        }
    }, [id]);

    if (loading) {
        return (
            <Helmet title="Loading...">
                <div className="product-detail-loading">
                    <div className="loading-spinner">Loading...</div>
                </div>
            </Helmet>
        );
    }

    if (error || !product) {
        return (
            <Helmet title="Error">
                <div className="product-detail-error">
                    <h2>Error</h2>
                    <p>{error || "Product not found"}</p>
                    <button onClick={() => navigate(-1)}>Go Back</button>
                </div>
            </Helmet>
        );
    }

    return (
        <Helmet title={product.productName || 'Product Details'}>
            <section className="product-detail">
                <div className="product-detail-container">
                    {/* Large Image on the Left */}
                    <div className="product-image-section">
                        <img
                            src={product.imgUrl?.[0] || product.imgUrl}
                            alt={product.productName || 'Product Image'}
                            className="product-detail-image"
                        />
                    </div>

                    {/* Details on the Right */}
                    <div className="product-info-section">
                        <div className="product-info-content">
                            {/* Product Name */}
                            <h1 className="product-detail-name">
                                {product.name}
                            </h1>

                            {/* Additional product details can be added here */}
                            {product.details && (
                                <div className="product-detail-price">
                                    <h3>{product.details}</h3>
                                </div>
                            )}

                            <div className="product-detail-description">
                                <p>Un plaisir de faire partie de la fraternité à vos côtés.</p>
                            </div>

                            {/* Instagram Link */}
                            {product.instagram && (
                                <div className="product-instagram">
                                    <h3>Instagram - {product.instagram}</h3>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                
                {/* Fixed Back Button at bottom right */}
                <div className="fixed-back-button-container">
                    <span 
                        className="back-button fixed-back-button"
                        onClick={() => navigate(-1)}
                    >
                        Return to Catalog
                    </span>
                </div>
            </section>
        </Helmet>
    );
};

export default RetinaProductDetail;